import { Link, Redirect } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbPage,
    BreadcrumbSeparator,
} from '@/ui/design-system/components';
import { SidebarTrigger } from '@/ui/design-system/components/ui/sidebar';
import { useAssistantContext } from 'components/AiAssistant';
import ReportBuildView from './ReportBuildView';
import useReportBuildStore from '@/state/stores/reportBuildStore';

// The breadcrumb header mirrors ReportView's so the build→view transition is
// continuous (no separate "Building report" chrome).
function BuildHeader({ current }) {
    return (
        <div className="flex items-center gap-3 px-4 py-3">
            <SidebarTrigger className="md:hidden" />
            <Breadcrumb>
                <BreadcrumbList>
                    <BreadcrumbItem>
                        <BreadcrumbLink asChild>
                            <Link to="/reports">Reports</Link>
                        </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                        <BreadcrumbPage>{current}</BreadcrumbPage>
                    </BreadcrumbItem>
                </BreadcrumbList>
            </Breadcrumb>
        </div>
    );
}

// Passive placeholder while the assistant builds the report in the panel chat
// (submitted from /reports). All the real work — research, create_report, and
// the navigation that replaces this page with the finished report — happens in
// the panel (AssistantProvider); this page just gives the build a place to
// land. The only live signal is the panel's loading state, which flips the
// caption when the chat settles without a report (failure or no widgets).
function ReportBuilder() {
    const [prompt] = useState(() => useReportBuildStore.getState().prompt);
    const clearBuild = useReportBuildStore((s) => s.clearBuild);
    const { isLoading } = useAssistantContext();

    // The store's prompt exists only to paint this placeholder; consume it on
    // exit (report opened, back to /reports, anywhere) so nothing goes stale.
    useEffect(() => () => clearBuild(), [clearBuild]);

    if (!prompt) return <Redirect to="/reports" />;

    return (
        <div>
            <BuildHeader current="Building report…" />
            <ReportBuildView prompt={prompt} isLoading={isLoading} />
        </div>
    );
}

export default ReportBuilder;
